import React, { useContext, useCallback, useState } from 'react';
import { Redirect, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useDropzone } from 'react-dropzone';

import '../static/css/Profile.css';
import GlobalContext, { articleDateConverter, trophyDateConverter, parseToken, titleEnding } from '../global';
import _fetchApi from '../fetch';
import UserAvatar from '../components/avatar';
import Loader from '../components/loaders';
import MainButton, { SecondaryButton } from '../components/buttons';
import LoginContainer, { connectTelegram, DisconnectButton, ConnectGoogleButton } from '../components/login';
import { ITMOButton } from '../components/itmo';
import { LabeledInput, TextLabeledInput } from '../components/inputs';
import { UnknownRank, ExpiredRank, SilverOneRank, SilverTwoRank, SilverThreeRank, GoldOneRank, GoldTwoRank, GoldThreeRank, PlatinumOneRank, PlatinumTwoRank, PlatinumThreeRank, TopRank } from '../components/ranks';

function CurrentRank(props) {
  switch (props.rank) {
    case -1:
      return <>
        <ExpiredRank />
        <span>Звание<br />устарело</span>
      </>;
    case 1:
      return <>
        <SilverOneRank />
        <span>Эникейщик</span>
      </>;
    case 2:
      return <>
        <SilverTwoRank />
        <span>Любитель</span>
      </>;
    case 3:
      return <>
        <SilverThreeRank />
        <span>Кандидат в<br />мастера</span>
      </>;
    case 4:
      return <>
        <GoldOneRank />
        <span>Мастер<br />первого ранга</span>
      </>;
    case 5:
      return <>
        <GoldTwoRank />
        <span>Мастер<br />второго ранга</span>
      </>;
    case 6:
      return <>
        <GoldThreeRank />
        <span>Мастер<br />третьего ранга</span>
      </>;
    case 7:
      return <>
        <PlatinumOneRank />
        <span>Кандидат в<br />гроссмейстеры</span>
      </>;
    case 8:
      return <>
        <PlatinumTwoRank />
        <span>Гроссмейстер</span>
      </>;
    case 9:
      return <>
        <PlatinumThreeRank />
        <span>Легендарный<br />гроссмейстер</span>
      </>;
    case 10:
      return <>
        <TopRank />
        <span>Абсолютный<br />чемпион</span>
      </>;
    default:
      return <>
        <UnknownRank />
        <span>Звание<br />неизвестно</span>
      </>;
  }
}

function PlatinumTrophy(props) {
  return <div className="trophy platinum-trophy">
    <svg width="91" height="90" viewBox="0 0 91 90" fill="none" xmlns="http://www.w3.org/2000/svg" className="rank-badge">
      <g clipPath="url(#clip0_4411:7577)">
        <path d="M13.3059 12.5H28.3059C31.0659 12.5 32.9984 12.24 32.9984 15V10C32.9984 7.24 31.0659 5 28.3059 5H8.30586C3.30586 5 -0.65164 10.3125 0.80586 17.5C0.80586 17.5 5.28336 40.9375 5.59836 42.395C6.43086 46.25 10.9084 50 15.7009 50H33.0959C35.8584 50 32.9984 45.26 32.9984 42.5V37.5C32.9984 40.26 31.0659 42.5 28.3059 42.5H18.3059C15.5459 42.5 13.7234 39.895 13.3059 37.5C12.8884 35.105 9.34586 19.1675 9.34586 19.1675C8.51336 14.375 10.5434 12.5 13.3059 12.5ZM77.8359 12.5H62.8359C60.0759 12.5 55.4984 12.24 55.4984 15V10C55.4984 7.24 60.0759 5 62.8359 5H82.8359C87.8359 5 91.7959 10.3125 90.3359 17.5C90.3359 17.5 86.2534 41.0475 85.9084 42.5C85.0234 46.25 80.8034 50 75.9084 50H58.0434C55.2834 50 55.4984 45.26 55.4984 42.5V37.5C55.4984 40.26 60.0759 42.5 62.8359 42.5H72.8359C75.5959 42.5 77.4209 39.895 77.8359 37.5C78.2509 35.105 81.7959 19.1675 81.7959 19.1675C82.6259 14.375 80.5984 12.5 77.8359 12.5ZM52.5784 55C52.5784 37.605 45.8059 55 45.8059 55C45.8059 55 38.3059 37.605 38.3059 55C38.3059 72.395 30.0784 80 30.0784 80H60.8084C60.8059 80 52.5784 72.395 52.5784 55Z" fill="var(--rank-gold-text)"/>
        <path d="M73.3066 16.4425C73.3066 33.38 56.3816 61.9225 45.8066 61.9225C35.2291 61.9225 18.3066 33.38 18.3066 16.4425C18.3066 3.455 20.8066 0.645 25.8066 0.645C29.2416 0.645 40.8691 0.5775 45.8066 0.5775L63.3066 0.575C70.5991 0.5725 73.3066 2.285 73.3066 16.4425Z" fill="var(--rank-gold-cup)"/>
        <path d="M68 82.5C68 85.26 68.5675 87.5 65.8075 87.5H25.8075C23.045 87.5 23 85.26 23 82.5V80C23 77.24 25.91 75 28.515 75H63.3075C65.9125 75 68 77.24 68 80V82.5Z" fill="#C1694F"/>
        <path d="M73 86.5625C73 88.4625 73.4125 90 69.87 90H21.745C18.515 90 18 88.4625 18 86.5625V85.9375C18 84.0375 19.845 82.5 21.745 82.5H69.87C71.7675 82.5 73 84.0375 73 85.9375V86.5625Z" fill="#C1694F"/>
      </g>
      <defs>
        <clipPath id="clip0_4411:7577">
          <rect width="90" height="90" fill="white" transform="translate(0.5)"/>
        </clipPath>
      </defs>
    </svg>
    <h3>{props.title}</h3>
    <p>{trophyDateConverter(props.date)}</p>
  </div>;  
}

function GoldTrophy(props) {
  return <div className="trophy gold-trophy">
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="rank-badge">
      <g clipPath="url(#clip0_4411:7674)">
        <path d="M20.5 8.88889L12.7222 0H0.5L16.0556 18.8889L28.8567 13.6111L20.5 8.88889Z" fill="#55ACEE"/>
        <path d="M28.2778 0L20.5 8.88889L26.4889 17.0133L27.8522 15.3589L40.5 0H28.2778Z" fill="#3B88C3"/>
        <path d="M26.3451 17.8067C26.434 17.5656 26.4907 17.3089 26.4907 17.0367C26.4907 15.81 25.4951 14.8145 24.2684 14.8145H16.8607C15.6329 14.8145 14.6384 15.81 14.6384 17.0367C14.6384 17.3089 14.694 17.5656 14.784 17.8067C11.164 19.8356 8.71289 23.7033 8.71289 28.1478C8.71289 34.6933 14.0184 40 20.5651 40C27.1107 40 32.4173 34.6933 32.4173 28.1478C32.4162 23.7033 29.9662 19.8356 26.3451 17.8067Z" fill="var(--rank-gold-text)"/>
        <path d="M20.5647 37.0367C25.4739 37.0367 29.4536 33.057 29.4536 28.1478C29.4536 23.2386 25.4739 19.2589 20.5647 19.2589C15.6555 19.2589 11.6758 23.2386 11.6758 28.1478C11.6758 33.057 15.6555 37.0367 20.5647 37.0367Z" fill="var(--rank-gold-inline)"/>
        <path d="M24.1426 34.0378C23.9849 34.0378 23.8271 33.9889 23.6915 33.8922L20.5004 31.6045L17.3104 33.8922C17.0382 34.0867 16.6737 34.0867 16.4037 33.8889C16.1337 33.6933 16.0204 33.3456 16.1204 33.0289L17.3104 29.1889L14.1493 26.9611C13.8804 26.7633 13.7693 26.4145 13.8715 26.0967C13.9749 25.78 14.2693 25.5645 14.6037 25.5622L18.5193 25.5567L19.766 21.8122C19.8715 21.4956 20.1671 21.2822 20.5015 21.2822C20.8349 21.2822 21.1315 21.4956 21.2371 21.8122L22.4626 25.5567L26.3982 25.5622C26.7326 25.5645 27.0282 25.78 27.1304 26.0967C27.2337 26.4145 27.1215 26.7622 26.8526 26.9611L23.6904 29.1889L24.8804 33.0289C24.9826 33.3467 24.8671 33.6933 24.5982 33.8889C24.4615 33.9889 24.3015 34.0378 24.1426 34.0378Z" fill="var(--rank-gold-text)"/>
      </g>
      <defs>
        <clipPath id="clip0_4411:7674">
          <rect width="40" height="40" fill="white" transform="translate(0.5)"/>
        </clipPath>
      </defs>
    </svg>
    <h3>{props.title}</h3>
    <p>{trophyDateConverter(props.date)}</p>
  </div>;
}

function SilverTrophy(props) {
  return <div className="trophy silver-trophy">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="rank-badge">
      <path d="M20 8.88889L12.2222 0H0L15.5556 18.8889L28.3567 13.6111L20 8.88889Z" fill="#55ACEE"/>
      <path d="M27.7778 0L20 8.88889L25.9889 17.0133L27.3522 15.3589L40 0H27.7778Z" fill="#3B88C3"/>
      <path d="M25.8451 17.8067C25.934 17.5656 25.9907 17.3089 25.9907 17.0367C25.9907 15.81 24.9951 14.8145 23.7684 14.8145H16.3607C15.1329 14.8145 14.1384 15.81 14.1384 17.0367C14.1384 17.3089 14.194 17.5656 14.284 17.8067C10.664 19.8356 8.21289 23.7033 8.21289 28.1478C8.21289 34.6933 13.5184 40 20.0651 40C26.6107 40 31.9173 34.6933 31.9173 28.1478C31.9162 23.7033 29.4662 19.8356 25.8451 17.8067Z" fill="var(--rank-silver-inline)"/>
      <path d="M20.0647 37.0367C24.9739 37.0367 28.9536 33.057 28.9536 28.1478C28.9536 23.2386 24.9739 19.2589 20.0647 19.2589C15.1555 19.2589 11.1758 23.2386 11.1758 28.1478C11.1758 33.057 15.1555 37.0367 20.0647 37.0367Z" fill="var(--rank-silver-inline)"/>
      <path d="M23.6426 34.0378C23.4849 34.0378 23.3271 33.9889 23.1915 33.8922L20.0004 31.6045L16.8104 33.8922C16.5382 34.0867 16.1737 34.0867 15.9037 33.8889C15.6337 33.6933 15.5204 33.3456 15.6204 33.0289L16.8104 29.1889L13.6493 26.9611C13.3804 26.7633 13.2693 26.4145 13.3715 26.0967C13.4749 25.78 13.7693 25.5645 14.1037 25.5622L18.0193 25.5567L19.266 21.8122C19.3715 21.4956 19.6671 21.2822 20.0015 21.2822C20.3349 21.2822 20.6315 21.4956 20.7371 21.8122L21.9626 25.5567L25.8982 25.5622C26.2326 25.5645 26.5282 25.78 26.6304 26.0967C26.7337 26.4145 26.6215 26.7622 26.3526 26.9611L23.1904 29.1889L24.3804 33.0289C24.4826 33.3467 24.3671 33.6933 24.0982 33.8889C23.9615 33.9889 23.8015 34.0378 23.6426 34.0378Z" fill="var(--rank-silver-text)"/>
    </svg>
    <h3>{props.title}</h3>
    <p>{trophyDateConverter(props.date)}</p>
  </div>;
}

function TelegramIcon(props) {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.95617 11.3922C7.73382 8.96891 11.5865 7.37133 13.5142 6.59946C19.0181 4.39561 20.1618 4.01278 20.9072 4.00013C21.0712 3.99735 21.4378 4.03647 21.6752 4.22196C21.8757 4.37858 21.9309 4.59016 21.9573 4.73865C21.9837 4.88715 22.0166 5.22542 21.9904 5.48974C21.6922 8.50665 20.4016 15.8279 19.745 19.2069C19.4672 20.6366 18.9162 20.9426 18.3866 20.9896C17.2357 21.0915 16.3657 20.4307 15.251 19.7273C13.5066 18.6265 12.8655 18.33 11.1723 17.2559C9.21554 16.0145 10.2831 15.3648 11.3983 14.2498C11.6901 13.958 16.7972 9.41227 16.8953 9.00946C16.9076 8.95908 16.7396 8.45538 16.6237 8.35622C16.5078 8.25706 16.3368 8.29097 16.2133 8.31794C16.0384 8.35616 13.2518 10.1293 7.85356 13.6372C7.0626 14.1601 6.34617 14.4149 5.70427 14.4015C4.99663 14.3868 3.63541 14.0163 2.62348 13.6997C1.38232 13.3113 0.924159 13.1284 1.01006 12.4687C1.0548 12.1252 1.37017 11.7663 1.95617 11.3922Z" fill={props.fill || "white"} />
  </svg>;
}

// Award type -> trophy component and grid modifier (the grid itself is CSS, see .cups-block)
const trophy_blocks = [
  {type: 2, Trophy: PlatinumTrophy, className: "cups-block"},
  {type: 3, Trophy: GoldTrophy, className: "cups-block"},
  {type: 4, Trophy: SilverTrophy, className: "cups-block silver"},
];

function ProfileSidebar(props) {
  const context = useContext(GlobalContext);

  if (props.cheater) {
    return <div className="profile-award-block">
      <div className="award-hidden-container">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36 18C36 27.941 27.941 36 18 36C8.059 36 0 27.941 0 18C0 8.059 8.059 0 18 0C27.941 0 36 8.059 36 18Z" fill="#BE1931"/>
          <path d="M32 20C32 21.104 31.104 22 30 22H6C4.896 22 4 21.104 4 20V16C4 14.896 4.896 14 6 14H30C31.104 14 32 14.896 32 16V20Z" fill="white"/>
        </svg>
        <p>Статистика не рассчитывается,<br />потому что пользователь пойман на списывании</p>
      </div>
    </div>;
  } else if (props.elite) {
    return <div className="profile-award-block">
      <div className="award-hidden-container">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33 36V35C33 31.687 30.313 29 27 29H9C5.687 29 3 31.687 3 35V36H33Z" fill="#66757F"/>
          <path d="M12 27.482C13.672 29.057 15.746 30 18 30C20.254 30 22.327 29.056 24 27.482V26H12V27.482Z" fill="#EF9645"/>
          <path d="M26.7492 20.4351C27.9372 20.6431 29.3682 20.5641 29.1652 21.3521C28.6862 23.2061 26.5612 22.5191 26.1862 22.5401C25.8112 22.5601 26.7492 20.4351 26.7492 20.4351Z" fill="#66757F"/>
          <path d="M27.0612 20.645C28.9362 20.895 29.6022 21.061 28.2272 21.603C27.4552 21.908 25.9842 26.406 24.8962 25.721C23.8092 25.036 27.0612 20.645 27.0612 20.645Z" fill="#292F33"/>
          <path d="M9.2557 20.4351C8.0677 20.6431 6.6367 20.5641 6.8397 21.3521C7.3187 23.2061 9.4437 22.5191 9.8187 22.5401C10.1937 22.5601 9.2557 20.4351 9.2557 20.4351Z" fill="#66757F"/>
          <path d="M8.94323 20.645C7.06823 20.895 6.40223 21.061 7.77723 21.603C8.54923 21.908 10.0202 26.406 11.1082 25.721C12.1962 25.036 8.94323 20.645 8.94323 20.645Z" fill="#292F33"/>
          <path d="M8.0542 11.031C6.1012 11.031 5.7492 14.195 7.3902 14.625C7.3902 14.625 6.0232 17.945 9.3432 17.945C8.7962 16.265 7.7812 13.531 8.5622 11.539L8.0542 11.031ZM27.9422 11.031C29.8952 11.031 30.2472 14.195 28.6062 14.625C28.6062 14.625 29.9732 17.945 26.6532 17.945C27.2002 16.265 28.2152 13.531 27.4342 11.539" fill="#FFAC33"/>
          <path d="M18 28C23.5228 28 28 22.4036 28 15.5C28 8.59644 23.5228 3 18 3C12.4772 3 8 8.59644 8 15.5C8 22.4036 12.4772 28 18 28Z" fill="#FFDC5D"/>
          <path d="M14 17C13.448 17 13 16.552 13 16V15C13 14.448 13.448 14 14 14C14.552 14 15 14.448 15 15V16C15 16.552 14.552 17 14 17ZM22 17C21.447 17 21 16.552 21 16V15C21 14.448 21.447 14 22 14C22.553 14 23 14.448 23 15V16C23 16.552 22.553 17 22 17Z" fill="#662113"/>
          <path d="M19 20.5C19 20.776 18.776 21 18.5 21H17.5C17.224 21 17 20.776 17 20.5C17 20.224 17.224 20 17.5 20H18.5C18.776 20 19 20.224 19 20.5Z" fill="#C1694F"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M7.65775 14.7879C7.80575 14.9349 8.54575 15.3789 8.69375 15.8219C8.84175 16.2649 9.13875 18.7759 10.0268 19.5149C10.9428 20.2769 14.3967 19.9929 15.0587 19.6639C16.5387 18.9259 16.7208 16.8659 16.9828 15.8219C17.1308 15.2309 18.0188 15.2309 18.0188 15.2309C18.0188 15.2309 18.9068 15.2309 19.0548 15.8219C19.3168 16.8659 19.4988 18.9259 20.9788 19.6629C21.6408 19.9929 25.0947 20.2769 26.0127 19.5159C26.8997 18.7769 27.1957 16.2659 27.3438 15.8219C27.4897 15.3789 28.2318 14.9359 28.3787 14.7879C28.5268 14.6399 28.5268 14.0489 28.3787 13.9009C28.0828 13.6059 24.5907 13.3419 20.8308 13.7529C20.0808 13.8349 19.7957 14.0479 18.0188 14.0479C16.2428 14.0479 15.9568 13.8339 15.2068 13.7529C11.4478 13.3419 7.95475 13.6049 7.65875 13.9009C7.50975 14.0489 7.50975 14.6409 7.65775 14.7879Z" fill="#292F33"/>
          <path d="M7.85707 8.39492C7.85707 8.39492 9.21607 -0.506077 13.7891 0.0229229C17.3011 0.428923 18.6791 0.847923 21.6221 0.119923C23.5691 -0.362077 25.6871 1.25592 26.9641 4.49892C27.7801 6.56692 28.1881 8.53992 28.1881 8.53992C28.1881 8.53992 32.1261 8.15492 32.3531 10.2719C32.5811 12.3889 27.9991 14.9879 16.4641 14.9879C9.99907 14.9869 3.32907 12.6299 3.01207 10.6569C2.69507 8.68392 7.85707 8.39492 7.85707 8.39492Z" fill="#66757F"/>
          <path d="M8.12406 7.1499C8.12406 7.1499 7.85406 8.2539 7.71806 9.0209C7.58206 9.7889 7.94406 10.3169 10.4231 10.8449C13.7101 11.5449 21.1021 11.5369 25.4811 10.4619C27.2401 10.0299 28.3671 9.7419 28.2321 8.8789C28.0651 7.8109 28.0361 7.8129 27.6911 6.6709C27.6911 6.6709 26.2141 7.1729 24.2641 7.6309C21.6041 8.2549 14.3001 8.5419 10.7831 7.7749C8.90906 7.3649 8.12406 7.1499 8.12406 7.1499ZM7.98806 21.1029C7.63406 21.2479 10.9091 22.4809 15.4681 22.5609C20.2391 22.6449 21.7021 22.9509 20.6141 24.0199C19.4681 25.1449 19.7621 26.9139 19.8431 27.4379C19.9241 27.9619 21.8901 29.3539 22.0511 29.9979C22.2121 30.6429 20.8221 35.9589 20.8221 35.9589L12.0931 35.7069C9.52806 26.8629 9.21006 27.2059 7.98806 22.1029C7.74706 21.0949 7.98806 21.1029 7.98806 21.1029Z" fill="#292F33"/>
          <path d="M6.98827 21.144C6.63427 21.29 9.90927 22.522 14.4683 22.602C19.2393 22.686 20.7023 22.992 19.6143 24.061C18.4683 25.186 18.9503 26.955 19.0313 27.479C19.1123 28.003 20.8903 29.395 21.0523 30.04C21.2123 30.684 19.8213 36 19.8213 36L11.0923 35.748C8.52727 26.904 8.20927 27.247 6.98727 22.144C6.74727 21.136 6.98827 21.144 6.98827 21.144Z" fill="#66757F"/>
          <path d="M28.0515 21.103C28.4055 21.248 25.1305 22.481 20.5725 22.561C15.8015 22.645 14.3385 22.951 15.4265 24.02C16.5725 25.145 18.4025 26.912 18.3225 27.436C18.2415 27.96 14.1505 29.354 13.9895 29.998C13.8285 30.643 15.2185 35.959 15.2185 35.959L23.9475 35.707C26.5125 26.863 26.8305 27.206 28.0515 22.103C28.2925 21.095 28.0515 21.103 28.0515 21.103Z" fill="#292F33"/>
          <path d="M28.9578 21.103C29.3118 21.248 26.0368 22.481 21.4788 22.561C16.7078 22.645 15.2448 22.951 16.3328 24.02C17.4788 25.145 19.3098 26.912 19.2288 27.436C19.1478 27.96 15.0568 29.354 14.8958 29.998C14.7348 30.643 16.1248 35.959 16.1248 35.959L24.7818 35.969C27.3468 27.125 27.7368 27.206 28.9588 22.103C29.1988 21.095 28.9578 21.103 28.9578 21.103Z" fill="#66757F"/>
        </svg>
        <p>Статистика не рассчитывается,<br />потому что это сотрудник Sort Me</p>
      </div>
    </div>;
  } else {
    return <div className="profile-award-block">
      <div className="award-rank-container">
        <div><CurrentRank rank={props.regal.rank_record.rank} /></div>
        {context.uid === props.uid && props.regal.rank_record.rank <= 0 ? <span>Поучаствуйте в Sort Me Round, чтобы получить звание. <a href="https://blog.sort-me.org/rating" target="_blank" rel="noreferrer">Подробнее</a></span> : <></>}
      </div>
      <div className="award-stats-container">
        <div className="tasks-solved">
          <h3>{props.regal.statistics.total}</h3>
          <span>Решено задач</span>
        </div>
        {props.regal.statistics.total ? <><div className="tasks-counter">
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.33377 11.6661C2.71988 11.6661 2.22266 11.1688 2.22266 10.5549V2.22161C2.22266 1.60772 2.71988 1.66605 3.33377 1.66605C3.94766 1.66605 4.44488 1.60772 4.44488 2.22161C4.44488 2.22161 4.10821 5.79049 4.44488 8.88661C4.74488 11.6499 6.6671 12.2216 6.6671 12.2216C6.6671 12.8355 3.94766 11.6661 3.33377 11.6661ZM11.1115 14.4433C10.4977 14.4433 10.0004 13.9461 10.0004 13.3322V1.6655C10.0004 1.05161 10.4977 1.10994 11.1115 1.10994C11.7254 1.10994 12.2227 1.05161 12.2227 1.6655C12.2227 1.6655 11.9749 4.50327 12.1532 6.83049C12.331 9.15661 12.2227 13.3322 12.2227 13.3322C12.2227 13.9455 11.7254 14.4433 11.1115 14.4433Z" fill="#7A5C44"/>
              <path d="M20 2.22198L0 4.4442V2.22198L20 1.11087V2.22198Z" fill="#662113"/>
              <path d="M12.5813 10.2258C12.2296 10.8513 11.8241 11.2308 11.3813 11.4441C11.158 11.4669 10.7524 11.3969 10.5941 10.6425C10.4096 9.76079 10.223 8.51301 10.223 6.97912C10.223 4.6769 10.5569 2.12246 10.5569 2.12246C10.5569 1.60635 11.3413 1.60246 11.7157 1.5719C11.6291 1.10968 10.7441 1.11079 9.66908 1.11079C8.86186 1.11079 8.41575 1.70746 8.33464 2.38912C8.25297 3.07135 7.8963 5.91524 7.9213 7.94468C7.93464 9.0469 8.00686 10.2563 8.0963 11.2869C7.6563 11.1752 7.21575 11.0686 6.78297 11.0141C5.22352 10.8163 3.16908 10.7169 2.82241 7.7469C2.54797 5.39579 2.77908 2.67801 2.77908 2.67801C2.77908 2.1619 3.56352 2.03468 3.93797 2.00412C3.8513 1.5419 3.00575 1.49801 1.93241 1.56912C1.12686 1.62246 0.687413 2.03801 0.556858 2.94468C0.346858 4.40524 0.322413 7.77135 0.445747 10.098C0.514636 11.3969 0.717969 16.0758 2.72297 17.8952C3.89408 18.9575 5.88297 19.5852 8.33464 19.4447C10.6596 19.3113 12.5696 18.4469 13.6391 17.5486C15.4957 15.9891 15.9113 14.8613 15.9885 13.6402C16.1124 11.6669 13.3457 8.86635 12.5813 10.2258Z" fill="#A78E81"/>
              <path d="M19.457 12.5941C18.2897 14.3725 15.9697 14.9125 13.4797 13.2786C10.9897 11.6447 10.5614 9.30135 11.7286 7.52302C12.8958 5.74469 15.8886 6.08747 17.4975 7.17635C19.1064 8.26524 20.6242 10.8158 19.457 12.5941Z" fill="#A78E81"/>
              <path d="M18.484 12.8773C17.6507 14.1479 15.6151 14.5351 13.4812 13.1351C11.3473 11.7351 11.0262 9.80121 11.8601 8.53066C12.6935 7.2601 14.2457 7.46344 16.3796 8.86399C18.5135 10.2645 19.3173 11.6073 18.484 12.8773Z" fill="#E2D2C7"/>
              <path d="M11.4261 8.09C11.1488 8.71556 11.05 9.38778 11.1533 10.0622C11.9855 10.3061 13.1739 10.6011 13.7366 10.4839C14.6511 10.2939 14.9577 9.47445 14.8233 8.82778C14.6372 7.93 13.0505 7.41445 11.4261 8.09Z" fill="#292F33"/>
              <path d="M12.994 9.86978C13.3585 9.86978 13.654 9.57429 13.654 9.20978C13.654 8.84527 13.3585 8.54977 12.994 8.54977C12.6295 8.54977 12.334 8.84527 12.334 9.20978C12.334 9.57429 12.6295 9.86978 12.994 9.86978Z" fill="#F5F8FA"/>
              <path d="M19.0587 13.0999C18.5954 13.6032 18.0181 13.9616 17.3581 14.1355C16.8031 13.4694 16.0598 12.496 15.9426 11.9332C15.7526 11.0188 16.3826 10.4116 17.0293 10.2771C17.9276 10.091 19.032 11.341 19.0587 13.0999Z" fill="#292F33"/>
              <path d="M17.4119 12.7676C17.7764 12.7676 18.0719 12.4721 18.0719 12.1076C18.0719 11.7431 17.7764 11.4476 17.4119 11.4476C17.0474 11.4476 16.752 11.7431 16.752 12.1076C16.752 12.4721 17.0474 12.7676 17.4119 12.7676Z" fill="#F5F8FA"/>
              <path d="M15.5788 12.4857C15.1788 13.0957 14.3599 13.2652 13.7504 12.8652C13.1404 12.4652 12.971 11.6463 13.371 11.0368C13.771 10.4268 14.2276 10.8091 14.8371 11.2091C15.4465 11.6091 15.9788 11.8757 15.5788 12.4857Z" fill="#292F33"/>
              <path d="M15.5412 13.9587C15.5278 13.9587 15.5139 13.9575 15.5006 13.9559C13.0123 13.5926 12.0023 11.6948 11.9606 11.6137C11.8906 11.4781 11.9434 11.3109 12.0795 11.2403C12.2162 11.1681 12.3828 11.2231 12.4539 11.3576C12.4634 11.3748 13.3834 13.0848 15.5812 13.4059C15.7328 13.4281 15.8378 13.5692 15.8162 13.7209C15.7956 13.8592 15.6773 13.9587 15.5412 13.9587Z" fill="#292F33"/>
            </svg>
            <span>{props.regal.statistics.difficulties[0]}</span>
          </div>
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.4957 2.56221C14.219 2.83888 14.1462 3.02833 14.0912 3.13388C13.7245 3.83721 13.2829 4.06499 12.5468 3.32888C12.4745 3.25666 10.2762 0.958325 9.91288 0.541659C9.67566 0.269436 9.31233 0.186103 9.03288 0.396103C8.82177 0.554992 6.79121 2.21444 6.23566 2.89999C5.80566 3.43055 5.79121 4.08555 6.19177 4.48666C6.37288 4.66777 6.59566 4.7361 6.83121 4.80777C7.13788 4.90166 7.81066 4.84555 8.20344 5.23833C8.83288 5.86777 8.50344 6.86277 7.69399 7.69444C6.86233 8.50388 5.86733 8.83332 5.23788 8.20388C4.84455 7.81055 4.90122 7.13832 4.80733 6.83166C4.73566 6.5961 4.66733 6.37388 4.48622 6.19221C4.08566 5.79166 3.43066 5.80666 2.89955 6.2361C2.21344 6.79166 0.554548 8.82221 0.395659 9.03333C0.185104 9.31277 0.268993 9.67555 0.541215 9.91332C0.957882 10.2767 3.25622 12.475 3.32844 12.5472C4.06399 13.2828 3.83677 13.725 3.13344 14.0917C3.02788 14.1467 2.83899 14.2189 2.56177 14.4961C1.74955 15.3083 1.74955 16.6255 2.56177 17.4378C3.37399 18.25 4.69121 18.25 5.50344 17.4378C5.7801 17.1611 5.85288 16.9717 5.90788 16.8661C6.27455 16.1628 6.71621 15.935 7.45233 16.6711C7.52455 16.7433 9.72288 19.0417 10.0862 19.4583C10.3234 19.7305 10.6868 19.8139 10.9662 19.6039C11.1773 19.445 13.2079 17.7855 13.7634 17.1C14.1934 16.5694 14.2079 15.9144 13.8073 15.5133C13.6262 15.3322 13.4034 15.2639 13.1679 15.1922C12.8612 15.0983 12.1884 15.1544 11.7957 14.7617C11.1662 14.1322 11.4957 13.1372 12.3051 12.3055C13.1368 11.4961 14.1318 11.1667 14.7612 11.7961C15.1545 12.1894 15.0979 12.8617 15.1918 13.1683C15.2634 13.4039 15.3318 13.6261 15.5129 13.8078C15.9134 14.2083 16.5684 14.1933 17.0995 13.7639C17.7857 13.2083 19.4445 11.1778 19.6034 10.9667C19.814 10.6872 19.7301 10.3244 19.4579 10.0867C19.0412 9.72332 16.7429 7.52499 16.6707 7.45277C15.9351 6.71721 16.1623 6.27499 16.8657 5.90833C16.9712 5.85332 17.1601 5.7811 17.4373 5.50388C18.2495 4.69166 18.2495 3.37444 17.4373 2.56221C16.6251 1.74944 15.3079 1.74944 14.4957 2.56221Z" fill="#78B159"/>
            </svg>
            <span>{props.regal.statistics.difficulties[1]}</span>
          </div>
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_4605:2070)">
                <path d="M19.8526 11.0717C19.6531 9.25555 19.4448 8.33333 18.8892 7.22222C18.8892 7.22222 20.5559 2.22222 19.4448 0.166665C19.0703 -0.525557 15.3314 1.10444 13.8892 2.22222C13.8892 2.22222 11.667 1.66778 10.0003 1.66778C8.33367 1.66778 6.11145 2.22222 6.11145 2.22222C4.66923 1.10444 0.930339 -0.525557 0.555894 0.166665C-0.555217 2.22222 1.11145 7.22222 1.11145 7.22222C0.555894 8.33333 0.347561 9.25555 0.148117 11.0717C-0.0713277 13.0628 0.365339 14.65 0.555894 15C0.772561 15.3978 1.87089 16.6806 3.33367 17.7778C5.55589 19.4444 8.88923 20 10.0003 20C11.1114 20 14.4448 19.4444 16.667 17.7778C18.1298 16.6806 19.2281 15.3978 19.4448 15C19.6353 14.65 20.072 13.0628 19.8526 11.0717Z" fill="#FFCC4D"/>
                <path d="M10.0007 10.8333C11.6673 10.8333 11.6673 11.1111 11.6673 11.6667C11.6673 12.2222 10.834 13.3333 10.0007 13.3333C9.16732 13.3333 8.33398 12.2222 8.33398 11.6667C8.33398 11.1111 8.33343 10.8333 10.0007 10.8333Z" fill="#E75A70"/>
                <path d="M1.11063 1.66671C1.35897 0.921155 4.24397 2.22227 4.79952 2.77782C4.79952 2.77782 2.22174 4.44449 1.66619 6.11115C1.66619 6.11115 0.555078 3.33338 1.11063 1.66671ZM18.8884 1.66671C18.6401 0.921155 15.7551 2.22227 15.1995 2.77782C15.1995 2.77782 17.7773 4.44449 18.3329 6.11115C18.3329 6.11115 19.444 3.33338 18.8884 1.66671Z" fill="#F18F26"/>
                <path d="M2.74023 3.11273C2.74023 2.32717 6.11023 3.88884 5.55468 4.44439C4.99912 4.99995 4.44357 5.33495 3.88801 5.8905C3.33246 6.44606 2.74023 3.66828 2.74023 3.11273ZM17.258 3.11273C17.258 2.32717 13.888 3.88884 14.4436 4.44439C14.9991 4.99995 15.5547 5.33495 16.1102 5.8905C16.6658 6.44606 17.258 3.66828 17.258 3.11273Z" fill="#FFCC4D"/>
                <path d="M0.39004 13.8889C0.307818 13.8889 0.226707 13.8528 0.171707 13.7833C0.0767068 13.6628 0.0972623 13.4883 0.217818 13.3933C0.307818 13.3228 2.45115 11.66 6.13337 11.9461C6.28615 11.9572 6.4006 12.0911 6.38893 12.2439C6.37726 12.3967 6.24615 12.5222 6.0906 12.4994C2.62782 12.2361 0.582262 13.8139 0.562262 13.83C0.510596 13.8694 0.45004 13.8889 0.39004 13.8889ZM5.31671 11.2983C5.28948 11.2983 5.26115 11.2944 5.23393 11.2861C2.57282 10.4544 0.38004 11.0933 0.357818 11.0994C0.210596 11.1444 0.0561512 11.0606 0.0117068 10.9133C-0.0321821 10.7661 0.0511512 10.6117 0.197818 10.5678C0.293929 10.5389 2.57893 9.875 5.39893 10.7556C5.5456 10.8017 5.62726 10.9572 5.58115 11.1039C5.54448 11.2222 5.43504 11.2983 5.31671 11.2983ZM19.6112 13.8889C19.6934 13.8889 19.7745 13.8528 19.8295 13.7833C19.9245 13.6628 19.9039 13.4883 19.7834 13.3933C19.6934 13.3228 17.55 11.66 13.8678 11.9461C13.715 11.9572 13.6006 12.0911 13.6123 12.2439C13.6239 12.3967 13.755 12.5222 13.9106 12.4994C17.3734 12.2361 19.4189 13.8139 19.4389 13.83C19.4906 13.8694 19.5512 13.8889 19.6112 13.8889ZM14.6845 11.2983C14.7117 11.2983 14.74 11.2944 14.7673 11.2861C17.4284 10.4544 19.6212 11.0933 19.6434 11.0994C19.7906 11.1444 19.945 11.0606 19.9895 10.9133C20.0334 10.7661 19.95 10.6117 19.8034 10.5678C19.7073 10.5389 17.4223 9.875 14.6023 10.7556C14.4556 10.8017 14.3739 10.9572 14.42 11.1039C14.4562 11.2222 14.5662 11.2983 14.6845 11.2983Z" fill="#FEE7B8"/>
                <path d="M14.0706 14.2344C13.9861 14.1611 13.8656 14.1461 13.7644 14.1961L11.5422 15.3072C10.5028 15.8266 7.805 15.8333 7.77778 15.8333C7.62444 15.8333 7.5 15.9577 7.5 16.1111C7.5 16.2138 7.55611 16.3038 7.63889 16.3516V16.3522H7.63944V16.3527C7.67889 16.3749 7.72444 16.3877 7.77278 16.3888H11.6661C13.1428 16.3888 13.9378 15.1744 14.1522 14.5322C14.1878 14.4255 14.1556 14.3083 14.0706 14.2344Z" fill="#292F33"/>
                <path d="M6.66775 10C7.2814 10 7.77886 9.12944 7.77886 8.05555C7.77886 6.98167 7.2814 6.11111 6.66775 6.11111C6.0541 6.11111 5.55664 6.98167 5.55664 8.05555C5.55664 9.12944 6.0541 10 6.66775 10Z" fill="#292F33"/>
                <path d="M13.3338 10C13.9474 10 14.4449 9.12944 14.4449 8.05555C14.4449 6.98167 13.9474 6.11111 13.3338 6.11111C12.7201 6.11111 12.2227 6.98167 12.2227 8.05555C12.2227 9.12944 12.7201 10 13.3338 10Z" fill="#292F33"/>
                <path d="M11.6676 6.66667C11.5254 6.66667 11.3832 6.61222 11.2748 6.50389C11.0576 6.28667 11.0576 5.93555 11.2748 5.71833C13.6326 3.36055 16.0115 3.33333 16.1121 3.33333C16.4193 3.33333 16.6676 3.58222 16.6676 3.88889C16.6676 4.195 16.4204 4.44333 16.1148 4.44444C16.0787 4.445 14.0665 4.49778 12.0604 6.50389C11.9521 6.61222 11.8098 6.66667 11.6676 6.66667ZM8.33428 6.66667C8.19206 6.66667 8.04983 6.61222 7.9415 6.50389C5.92706 4.49 3.90706 4.44444 3.88706 4.44444C3.58095 4.44111 3.33428 4.19167 3.33595 3.88611C3.33761 3.58 3.58428 3.33333 3.88983 3.33333C3.98983 3.33333 6.36928 3.36055 8.72706 5.71833C8.94428 5.93555 8.94428 6.28667 8.72706 6.50389C8.61872 6.61222 8.4765 6.66667 8.33428 6.66667Z" fill="#292F33"/>
              </g>
              <defs>
                <clipPath id="clip0_4605:2070">
                  <rect width="20" height="20" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <span>{props.regal.statistics.difficulties[2]}</span>
          </div>
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 10C20 15.5228 15.5228 20 10 20C4.47778 20 0 15.5228 0 10C0 4.47778 4.47778 0 10 0C15.5228 0 20 4.47778 20 10Z" fill="#DA2F47"/>
              <path d="M14.1584 16.5994C14.1334 16.5 13.5095 14.1667 10.0001 14.1667C6.4901 14.1667 5.86676 16.5 5.84176 16.5994C5.81121 16.72 5.86565 16.845 5.97343 16.9072C6.08176 16.9678 6.21732 16.9511 6.30676 16.8644C6.31732 16.8539 7.39232 15.8333 10.0001 15.8333C12.6079 15.8333 13.6834 16.8539 13.6934 16.8639C13.7468 16.9167 13.8179 16.9444 13.889 16.9444C13.9357 16.9444 13.9829 16.9328 14.0257 16.9089C14.1345 16.8467 14.189 16.7206 14.1584 16.5994ZM8.72621 8.49611C6.91787 6.68778 4.01176 6.66667 3.88899 6.66667C3.58232 6.66667 3.33399 6.915 3.33399 7.22111C3.33343 7.52778 3.58176 7.77667 3.88843 7.77778C3.90454 7.77778 4.95787 7.79056 6.10121 8.18722C5.77176 8.54278 5.55565 9.095 5.55565 9.72222C5.55565 10.7967 6.17732 11.6667 6.94454 11.6667C7.71176 11.6667 8.33343 10.7967 8.33343 9.72222C8.33343 9.62556 8.32287 9.53333 8.31287 9.44056C8.3201 9.44056 8.32676 9.44445 8.33343 9.44445C8.47565 9.44445 8.61787 9.39 8.72621 9.28167C8.94343 9.06445 8.94343 8.71333 8.72621 8.49611ZM16.1112 6.66667C15.9884 6.66667 13.0829 6.68778 11.274 8.49611C11.0568 8.71333 11.0568 9.06445 11.274 9.28167C11.3823 9.39 11.5245 9.44445 11.6668 9.44445C11.674 9.44445 11.6801 9.44056 11.6868 9.44056C11.6779 9.53333 11.6668 9.62556 11.6668 9.72222C11.6668 10.7967 12.2884 11.6667 13.0557 11.6667C13.8229 11.6667 14.4445 10.7967 14.4445 9.72222C14.4445 9.095 14.2284 8.54278 13.899 8.18722C15.0423 7.79056 16.0957 7.77778 16.1123 7.77778C16.4184 7.77667 16.6668 7.52778 16.6662 7.22111C16.6657 6.915 16.4179 6.66667 16.1112 6.66667Z" fill="#292F33"/>
              <path d="M16.5221 18.3333H3.47877C2.78766 18.3333 2.22266 17.7683 2.22266 17.0772V13.8889C2.22266 13.1978 2.78766 12.6328 3.47877 12.6328H16.5221C17.2132 12.6328 17.7782 13.1978 17.7782 13.8889V17.0772C17.7782 17.7683 17.2132 18.3333 16.5221 18.3333Z" fill="#292F33"/>
              <path d="M4.35635 15.1272H3.9019C3.72746 15.1272 3.64801 15 3.64801 14.8733C3.64801 14.7466 3.72746 14.62 3.9019 14.62H4.42968L4.54579 13.77C4.5719 13.58 4.65135 13.5166 4.80968 13.5166C4.93635 13.5166 5.05301 13.6005 5.05301 13.7277C5.05301 13.8072 5.05301 13.77 5.04246 13.855L4.9369 14.6205H5.44412L5.56023 13.7705C5.58635 13.5805 5.66579 13.5172 5.82412 13.5172C5.95079 13.5172 6.06746 13.6011 6.06746 13.7283C6.06746 13.8077 6.06746 13.7705 6.0569 13.8555L5.95079 14.6211H6.40523C6.57968 14.6211 6.65857 14.7483 6.65857 14.8744C6.65857 15.0011 6.57912 15.1283 6.40523 15.1283H5.8769L5.79246 15.73H6.2469C6.42135 15.73 6.50023 15.8572 6.50023 15.9839C6.50023 16.1105 6.42079 16.2372 6.2469 16.2372H5.71857L5.60246 17.0872C5.57579 17.2777 5.49635 17.3405 5.33801 17.3405C5.21135 17.3405 5.09468 17.2566 5.09468 17.1294C5.09468 17.05 5.09468 17.0872 5.10523 17.0022L5.21135 16.2366H4.70468L4.58857 17.0866C4.5619 17.2772 4.48301 17.34 4.32412 17.34C4.19746 17.34 4.08079 17.2561 4.08079 17.1289C4.08079 17.0494 4.08079 17.0866 4.09135 17.0016L4.1969 16.2361H3.74357C3.56968 16.2361 3.49023 16.1088 3.49023 15.9827C3.49023 15.8555 3.56968 15.7289 3.74357 15.7289H4.2719L4.35635 15.1272ZM4.78412 15.7289H5.28579L5.37023 15.1272H4.86857L4.78412 15.7289ZM7.34857 14.34C7.34857 13.8805 7.6919 13.4844 8.1619 13.4844C8.6319 13.4844 8.97523 13.8805 8.97523 14.34C8.97523 14.7994 8.6319 15.1905 8.1619 15.1905C7.69135 15.1911 7.34857 14.8 7.34857 14.34ZM8.43635 14.34C8.43635 14.1711 8.33579 14.0233 8.1619 14.0233C7.98746 14.0233 7.8869 14.1716 7.8869 14.34C7.8869 14.5094 7.98746 14.6522 8.1619 14.6522C8.33579 14.6522 8.43635 14.5094 8.43635 14.34ZM9.71968 13.6222C9.78857 13.4905 9.84135 13.4533 9.96301 13.4533C10.1269 13.4533 10.2747 13.585 10.2747 13.7489C10.2747 13.7911 10.2747 13.8283 10.2325 13.9072L8.45801 17.2288C8.37857 17.3394 8.3469 17.4027 8.22023 17.4027C8.08301 17.4027 7.91912 17.2711 7.91912 17.1127C7.91912 17.0333 7.95079 16.96 7.9719 16.9172L9.71968 13.6222ZM9.20746 16.5216C9.20746 16.0622 9.55079 15.6661 10.0208 15.6661C10.4908 15.6661 10.8341 16.0622 10.8341 16.5216C10.8341 16.9805 10.4908 17.3716 10.0208 17.3716C9.55023 17.3722 9.20746 16.9805 9.20746 16.5216ZM10.2952 16.5216C10.2952 16.3522 10.1947 16.205 10.0202 16.205C9.84579 16.205 9.74523 16.3527 9.74523 16.5216C9.74523 16.6905 9.84579 16.8333 10.0202 16.8333C10.1947 16.8333 10.2952 16.6905 10.2952 16.5216ZM11.6763 16.96C11.6763 16.7327 11.8613 16.5477 12.088 16.5477C12.3152 16.5477 12.5002 16.7327 12.5002 16.96C12.5002 17.1866 12.3152 17.3716 12.088 17.3716C11.8613 17.3722 11.6763 17.1872 11.6763 16.96ZM11.708 13.8439C11.708 13.6222 11.8713 13.485 12.088 13.485C12.2997 13.485 12.4686 13.6277 12.4686 13.8439V15.8772C12.4686 16.0939 12.2997 16.2361 12.088 16.2361C11.8713 16.2361 11.708 16.0989 11.708 15.8772V13.8439ZM16.1958 17.4033C16.0919 17.4033 16.0269 17.3738 15.9563 17.2944L15.5541 16.8555L15.5141 16.8922C15.1241 17.2505 14.7875 17.4027 14.3897 17.4027C13.7736 17.4027 13.1513 17.0516 13.1513 16.2672C13.1513 15.6522 13.633 15.2844 13.9202 15.12L13.9852 15.0827L13.9325 15.0283C13.6963 14.7811 13.5997 14.5766 13.5997 14.3233C13.5997 13.725 14.1458 13.4527 14.653 13.4527C15.0775 13.4527 15.6752 13.7044 15.6752 14.2627C15.6752 14.7911 15.1847 15.0966 15.0347 15.1777L14.9708 15.2122L15.6158 15.9572L15.8625 15.6594C15.9997 15.4944 16.0797 15.425 16.2213 15.425C16.3352 15.425 16.4569 15.5272 16.4569 15.7155C16.4569 15.8566 16.3169 16.0405 16.1797 16.2016L16.0147 16.3877L16.4069 16.8533C16.4797 16.94 16.5097 16.9861 16.5097 17.0911C16.5102 17.255 16.3602 17.4033 16.1958 17.4033ZM14.2808 15.4733C14.043 15.6327 13.8008 15.8427 13.8008 16.1905C13.8008 16.555 14.038 16.79 14.4058 16.79C14.7125 16.79 14.9108 16.6555 15.1141 16.4533L15.1536 16.415L14.3202 15.4466L14.2808 15.4733ZM14.6536 13.9672C14.498 13.9672 14.2813 14.0944 14.2813 14.3016C14.2813 14.495 14.3763 14.6127 14.578 14.8177L14.6063 14.8466L14.6413 14.8283C14.9175 14.6839 15.0575 14.5211 15.0575 14.3455C15.058 14.0855 14.8486 13.9672 14.6536 13.9672Z" fill="white"/>
            </svg>
            <span>{props.regal.statistics.difficulties[3]}</span>
          </div>
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.2218 6.66667L16.4373 12.3528L4.08457 20L2.77734 15.5556L17.2218 6.66667Z" fill="#C1694F"/>
              <path d="M0.554688 12.2222V16.4706L4.08413 20V15.5556L0.554688 12.2222Z" fill="#662113"/>
              <path d="M18.8886 2.77778V7.05889L16.4375 12.3528V8.33333L17.2219 5L18.8886 2.77778Z" fill="#A04E3C"/>
              <path d="M18.888 2.77778L16.4369 8.23556L4.08413 15.8822L0.554688 12.2222L9.96635 1.17667L15.8486 0L18.888 2.77778Z" fill="#D99E82"/>
              <path d="M6.66737 16.6666C6.48792 16.6666 6.31181 16.5799 6.20459 16.4194C6.03459 16.1638 6.10348 15.8194 6.35848 15.6488L8.02515 14.5377C8.28015 14.3672 8.62515 14.4361 8.7957 14.6916C8.9657 14.9472 8.89681 15.2916 8.64181 15.4622L6.97515 16.5733C6.88015 16.6361 6.77292 16.6666 6.66737 16.6666ZM12.7785 12.7777C12.599 12.7777 12.4224 12.6911 12.3157 12.5305C12.1451 12.2749 12.214 11.9305 12.4696 11.7599L14.1363 10.6488C14.3924 10.4788 14.7363 10.5477 14.9068 10.8027C15.0774 11.0583 15.0085 11.4027 14.7529 11.5733L13.0863 12.6844C12.9913 12.7472 12.884 12.7777 12.7785 12.7777Z" fill="#FFAC33"/>
              <path d="M5.00019 13.8889C4.85686 13.8889 4.71464 13.8333 4.60686 13.7261L2.94019 12.0594C2.72797 11.8472 2.72241 11.5056 2.92797 11.2867L11.2613 2.39777C11.3446 2.30888 11.4552 2.25 11.5752 2.23L14.9085 1.67444C15.0835 1.64444 15.2652 1.70222 15.3924 1.82944L16.5035 2.94055C16.6613 3.09777 16.7096 3.33333 16.6274 3.54L15.5163 6.31777C15.4774 6.41555 15.4113 6.5 15.3257 6.56166L5.32575 13.7839C5.22797 13.8544 5.11408 13.8889 5.00019 13.8889ZM4.10686 11.6544L5.05853 12.6061L14.5446 5.755L15.4591 3.46666L14.8096 2.81666L11.9435 3.29444L4.10686 11.6544Z" fill="#C1694F"/>
            </svg>
            <span>{props.regal.statistics.difficulties[4]}</span>
          </div>
        </div>
        <span>Последняя успешная попытка: {props.regal.statistics.last_accepted ? articleDateConverter(props.regal.statistics.last_accepted) : "никогда"}</span></> : <></>}
      </div>
      {props.regal.awards.length > 0 ? <div className="award-cups-container">
        <p>Награды</p>
        {trophy_blocks.map(({type, Trophy, className}) => {
          const awards = props.regal.awards.filter(award => award.type === type);
          return awards.length > 0 && <div key={type} className={className}>
            {awards.map((award, index) => <Trophy key={index} title={award.title} date={award.date} />)}
          </div>;
        })}
      </div> : <></>}
    </div>;
  }
}

class Profile extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.state = {
      uid: null,
      login: null,
      name: null,
      avatar: null,
      bio: null,
      registered_at: null,
      integrations: null,
      regal: {
        statistics: {
          difficulties: null,
          total: null,
          last_accepted: null,
        },
        awards: [],
        rank_record: {
          rank: null,
          silver: null,
          gold: null,
        },
      },
      elite: null,
      cheater: null,

      telegram_error: "Аккаунт уже привязан",
    };
  }

  getUserData() {
    let response = _fetchApi("/getUserById?id=" + this.props.params.user_id, this.context.token ? {
      method: "GET",
      headers: {"Authorization": "Bearer " + this.context.token,},
    } : {method: "GET",}).then(response => response.json());
    response.then(result => {
      if (result.hasOwnProperty("error")) {
        this.setState({uid: "error",});
      } else {
        this.setState(result);
      }
    });
  }

  componentDidMount() {
    document.title = "Профиль" + titleEnding;


    this.getUserData();
  }

  render() {
    // Unexisting user
    if (this.state.uid === "error") {
      return <div className="main-content">
        <button className="profile-back-link" onClick={this.props.history.goBack}>← Обратно</button>
        <div className="profile-error-block">
          <h2>Пользователь не найден</h2>
          <p>Этот пользователь ещё не познал всю красоту спортивного программирования</p>
        </div>
      </div>;

    // Myself or another person
    } else if (this.state.uid) {
      const is_me = this.state.uid === this.context.uid;

      // DOM order = phone order (header, stats, about, integrations, actions); desktop places the blocks with a CSS grid
      return <div className="main-content profile-container">
        <button className="profile-back-link" onClick={this.props.history.goBack}>← Обратно</button>
        <div className="profile-personal-block">
          <UserAvatar src={this.state.avatar} size={100} />
          <div className="profile-name">
            <h2 style={this.state.login === "Goosescout" ? { // KekW
              color: "unset",
              background: "-webkit-linear-gradient(0deg, rgba(0,81,250,1) 0%, rgba(131,58,180,1) 25%, rgba(253,29,29,1) 50%, rgba(245,205,59,1) 75%, rgba(0,255,20,1) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            } : {}} title={this.state.login}>{this.state.login}</h2>
            <p>{this.state.name}</p>
          </div>
        </div>
        <ProfileSidebar {...this.state} />
        {this.state.bio ? <div className="profile-bio-block">
          <h2>О себе</h2>
          <p>{this.state.bio}</p>
        </div> : <></>}
        <div className="profile-since-block">
          <span>На Sort Me с {articleDateConverter(this.state.registered_at)} г.</span>
        </div>
        {is_me ? <div className="profile-auth-block">
          {this.state.integrations.hasOwnProperty("telegram") ? <div className="profile-account telegram"> {/* Normal telegram block */}
            <div>
              <TelegramIcon fill="#69A8E5" />
              <span>Telegram</span>
            </div>
            <span>{this.state.integrations.telegram}</span>
            {Object.keys(this.state.integrations).length > 1 && <DisconnectButton className="profile-disconnect" onClick={() => this.props.refreshPage()} provider="telegram">Отвязать</DisconnectButton>}
          </div> : <div className="profile-telegram-proposal"> {/* Huge telegram proposal */}
            <svg width="199" height="140" viewBox="0 0 199 140" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M9.74383 75.33C68.6208 50.6355 107.881 34.3554 127.525 26.4897C183.613 4.03143 195.268 0.130195 202.864 0.00137354C204.535 -0.0269595 208.271 0.371647 210.69 2.26186C212.734 3.85792 213.296 6.01397 213.565 7.52721C213.834 9.04045 214.169 12.4877 213.903 15.1812C210.863 45.9249 197.712 120.532 191.021 154.965C188.19 169.535 182.574 172.654 177.178 173.132C165.449 174.171 156.584 167.437 145.224 160.268C127.449 149.051 120.915 146.03 103.661 135.084C83.7203 122.434 94.5992 115.813 105.963 104.45C108.937 101.476 160.981 55.1536 161.981 51.0487C162.106 50.5354 160.394 45.4024 159.213 44.392C158.032 43.3815 156.289 43.7271 155.031 44.0019C153.248 44.3914 124.852 62.4601 69.8411 98.208C61.7808 103.536 54.48 106.132 47.9387 105.996C40.7275 105.846 26.8561 102.071 16.5441 98.8443C3.89599 94.8863 -0.772858 93.0223 0.102485 86.3004C0.558417 82.7993 3.7722 79.1425 9.74383 75.33Z" fill="white" fillOpacity="0.29"/>
            </svg>
            <h2>
              Привяжите Telegram
            </h2>
            <ul>
              <li>Уведомления о контестах</li>
              <li>Удобный бот</li>
              <li>Чат пользователей Sort Me</li>
            </ul>
            <MainButton
              className="telegram-auth-button"
              error={<>
                <TelegramIcon />
                {this.state.telegram_error}
              </>}
              loading={<>
                <TelegramIcon />
                Входим...
              </>}
              onClick={async () => {await connectTelegram({
                onSuccess: () => this.props.refreshPage(),
                onFailure: (response) => {
                  if (response === "Telegram api error") {
                    this.setState({telegram_error: "Ошибка",});
                  } else {
                    this.setState({telegram_error: "Аккаунт уже привязан",});
                  }
                },
                token: this.context.token,
              });
              return {"error": this.state.telegram_error, "error_text": <><TelegramIcon />{this.state.telegram_error}</>,};}}
            >
              <TelegramIcon />
              Войти через Telegram
            </MainButton>
          </div>}
          <div className="profile-account google">
            <div>
              <svg width="24" height="24" viewBox="-3 -3 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M17.64 9.2C17.64 8.563 17.583 7.949 17.476 7.36H9V10.841H13.844C13.635 11.966 13.001 12.919 12.048 13.558V15.816H14.956C16.658 14.249 17.64 11.942 17.64 9.201V9.2Z" fill="#4285F4"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M9.00394 18C11.4339 18 13.4709 17.194 14.9599 15.82L12.0509 13.56C11.2449 14.1 10.2149 14.42 9.00394 14.42C6.65994 14.42 4.67594 12.836 3.96794 10.709H0.960938V13.041C2.44094 15.983 5.48594 18 9.00394 18Z" fill="#34A853"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M3.964 10.712C3.784 10.172 3.682 9.595 3.682 9.002C3.682 8.409 3.784 7.832 3.964 7.292V4.96H0.957C0.347 6.175 0 7.55 0 9.002C0 10.454 0.348 11.829 0.957 13.044L3.964 10.712Z" fill="#FBBC05"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M9.00394 3.58C10.3249 3.58 11.5119 4.034 12.4439 4.925L15.0259 2.345C13.4649 0.891 11.4289 0 9.00294 0C5.48594 0 2.44094 2.017 0.960938 4.958L3.96794 7.29C4.67594 5.163 6.65994 3.58 9.00394 3.58Z" fill="#EA4335"/>
              </svg>
              <span>Google</span>
            </div>
            {this.state.integrations.hasOwnProperty("google") ? <>
              <span>{this.state.integrations.google}</span>
              {Object.keys(this.state.integrations).length > 1 && <DisconnectButton className="profile-disconnect" onClick={() => this.props.refreshPage()} provider="google">Отвязать</DisconnectButton>}</> : <>
              <ConnectGoogleButton onSuccess={() => this.props.refreshPage()} token={this.context.token}>Привязать</ConnectGoogleButton>
            </>}
          </div>
          <div className="profile-account itmo">
            <div><span>ITMO ID</span></div>
            {this.state.integrations.hasOwnProperty('itmo') ? <>
              <span title={this.state.integrations.itmo}>{this.state.integrations.itmo}</span>
              {Object.keys(this.state.integrations).length > 1 && <DisconnectButton className="profile-disconnect" onClick={() => this.props.refreshPage()} provider="itmo">Отвязать</DisconnectButton>}
            </> : <ITMOButton connect>Привязать</ITMOButton>}
          </div>
        </div> : <></>}
        {is_me ? <div className="profile-actions-block">
          <SecondaryButton
            className="profile-edit-button"
            onClick={() => this.props.history.push("/profile/edit")}
          >Редактировать</SecondaryButton>
          <SecondaryButton
            className="profile-exit-button"
            onClick={async () => {
              // Wait for the revoke: navigating away would cancel the request
              await _fetchApi("/oauth/revoke", {
                method: "POST",
                headers: {"Authorization": "Bearer " + this.context.token,},
              }).catch(() => {});
              Cookies.remove("user_data", {path: "/",});
              window.location.assign("/");
            }}
          >Выйти из аккаунта</SecondaryButton>
        </div> : <></>}
      </div>;

    // Loading
    } else {
      return <div className="main-content">
        <button className="profile-back-link" onClick={this.props.history.goBack}>← Обратно</button>
        <Loader width="60" height="60" />
      </div>;
    }
  }
}

function AvatarInput(props) {
  const [current_text, setText] = useState("Загрузить другую");
  const [avatar_src, setAvatarSrc] = useState(props.src);
  const { callback } = props;

  const onDrop = useCallback(acceptedFile => {
    acceptedFile.forEach(file => {
      setText("Загружаем...");

      const reader = new FileReader();

      reader.onabort = () => setText("Загрузка прервана");
      reader.onerror = () => setText("Загрузка прервана");
      reader.onload = async () => {
        let form_data = new FormData();
        form_data.append("document", file);

        let response = await fetch("https://pic.sort-me.org/store", {
          mode: "cors",
          method: "POST",
          body: form_data,
        }).then(response => {
          if (response.status > 300) {
            return response.text();
          } else {
            return response.json();
          }
        }).catch(() => null);

        if (response === "Request Entity Too Large") {
          setText("Файл слишком большой");
        } else if (!response?.id) {
          setText("Ошибка загрузки");
        } else {
          setAvatarSrc(reader.result);
          callback(response.id);
          setText("Загружено");
        }
      };

      reader.readAsDataURL(file);
    });
  }, [callback]);
  
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop, multiple: false, accept: "image/jpeg, image/webp, image/png",});

  return <div {...getRootProps()}>
    <UserAvatar src={avatar_src} size={100} />
    <SecondaryButton className="profile-avatar-upload">
      <input {...getInputProps()} />
      {isDragActive ? "Отпускайте!" : current_text}
    </SecondaryButton></div>;
}

class ProfileEdit extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.state = {
      uid: null,
      login: null,
      name: null,
      avatar: null,
      bio: null,
      registered_at: null,
      integrations: null,

      /* errors */
      login_error: null,
      name_error: null,

      /* should redirect user */
      redirect: false,
    };
  }

  getUserData() {
    let response = _fetchApi("/getUserById?id=" + this.context.uid, {
      method: "GET",
      headers: {"Authorization": "Bearer " + this.context.token,},
    }).then(response => response.json());
    response.then(result => {
      this.setState(result);
    });
  }

  componentDidMount() {
    document.title = "Редактирование профиля" + titleEnding;


    this.getUserData();
  }

  render() {
    if (this.state.uid) {
      return <div className="main-content">
        <Link className="profile-back-link" to={"/profile/" + this.context.uid}>← Мой профиль</Link>
        <div className="profile-edit-block">
          <h2>Редактировать профиль</h2>
          <div className="profile-avatar-edit">
            <span>Аватарка</span>   
            <AvatarInput src={this.state.avatar} callback={id => {
              this.setState({avatar: "https://pic.sort-me.org/" + id,});
            }} />
          </div>
          <div className="profile-text-edit">
            <LabeledInput
              id="profile-login-input"
              title="Никнейм"
              maxLength={32}
              placeholder="Никнейм"
              defaultValue={this.state.login}
              errorText={this.state.login_error}
              onChange={() => {
                if (this.state.login_error) {
                  this.setState({login_error: null,});
                }
              }}
            />
            <LabeledInput
              id="profile-name-input"
              title="Настоящее имя"
              maxLength={64}
              placeholder="Имя"
              defaultValue={this.state.name}
              errorText={this.state.name_error}
              onChange={() => {
                if (this.state.name_error) {
                  this.setState({name_error: null,});
                }
              }}
            />
            <TextLabeledInput
              id="profile-bio-input"
              title="О себе"
              maxLength={1024}
              placeholder="О себе"
              defaultValue={this.state.bio}
            />
          </div>
          <MainButton
            className="profile-save-edit"
            onClick={async () => {
              let response = await _fetchApi("/editMyProfile", {
                method: "POST",
                headers: {"Authorization": "Bearer " + this.context.token,
                          "Content-Type": "application/json",},
                body: JSON.stringify({
                  avatar: this.state.avatar,
                  login: document.getElementById("profile-login-input").value,
                  name: document.getElementById("profile-name-input").value,
                  bio: document.getElementById("profile-bio-input").value,
                }),
              }).then(response => response.json());
              if (response.hasOwnProperty("error")) {
                if (response.error === "login is taken") {
                  this.setState({login_error: <>Блин,<br /> занятый логин</>, name_error: null,});
                } else if (response.error === "login is incorrect") {
                  this.setState({login_error: <>Некорректный логин</>, name_error: null,});
                } else if (response.error === "Invalid request body") {
                  if (response.detail.includes("Login is required field") && response.detail.includes("Name is required field")) {
                    this.setState({login_error: <>Необходимо заполнить</>, name_error: <>Необходимо заполнить</>,});
                  } else if (response.detail.includes("Login is required field")) {
                    this.setState({login_error: <>Необходимо заполнить</>, name_error: null,});
                  } else if (response.detail.includes("Name is required field")) {
                    this.setState({login_error: null, name_error: <>Необходимо заполнить</>,});
                  }
  
                } else {
                  this.setState({login_error: <>Мне не<br />понравилось</>, name_error: null,});
                }
              } else {
                const new_login = document.getElementById("profile-login-input").value;

                let current_user_data = Cookies.getJSON("user_data");
                current_user_data.login = new_login;

                const parsed_token = parseToken(this.context.token);

                Cookies.remove("user_data", {path: "/",});
                Cookies.set("user_data", current_user_data, {expires: new Date(parsed_token.exp * 1000), path: "/",});
                this.context.setNewData(new_login, this.state.avatar);
                this.setState({redirect: true,});
              }
            }}
          >Сохранить</MainButton>
          {this.state.redirect && <Redirect to={"/profile/" + this.context.uid} />}
        </div>
      </div>;
    } else {
      return <div className="main-content">
        <button className="profile-back-link" onClick={this.props.history.goBack}>← Обратно</button>
        <Loader width="60" height="60" />
      </div>;
    }
  }
}

const ProfileWrapper = (props) => {
  const params = useParams();
  const context = useContext(GlobalContext);
  const [key, setKey] = useState(0);

  function refreshPage() {
    setKey(key + 1);
  }

  if (params.hasOwnProperty("user_id") && params.user_id === "edit") {
    return context.login ? <ProfileEdit {...props} /> : <Redirect to="/" />;
  } else if (params.hasOwnProperty("user_id")) {
    return <Profile {...props} key={key} params={params} refreshPage={() => refreshPage()} />;
  } else {
    // Guests stay on /profile (the phone tab bar links here) and get a sign-in screen
    return context.login ? <Redirect to={"/profile/" + context.uid} /> : <div className="main-content">
      <h1 className="header">Профиль</h1>
      <LoginContainer title="Войдите, чтобы открыть профиль" />
    </div>;
  }
}

export default ProfileWrapper;
